var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HistoryActions } from 'app/stores/history/actions';
import { getProjectState, projectSlice } from 'app/stores/project';
import { getPageKeyForMarkerAlias } from 'app/stores/project/page';
import { getMarker, getSizeFactor } from 'app/stores/selectors';
import { updatePinOnSizeChange } from 'app/utils/markers';
export const deleteItems = createAsyncThunk('project/deleteItem', (props, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const { ids, undoable } = props;
    if (!ids || !ids.length) {
        return;
    }
    let state = getState();
    let projectState = getProjectState(state);
    const modifiedMarkerSets = ids.reduce((set, id) => {
        const marker = getMarker(state, id);
        set.add(getPageKeyForMarkerAlias(marker.alias));
        return set;
    }, new Set());
    // only pins at this time require any extra modifications
    if (!modifiedMarkerSets.has('pins')) {
        dispatch(projectSlice.actions.itemDelete({ ids, undoable }));
        return;
    }
    if (!configGet('renumeratePinsAfterDeletion', true)) {
        dispatch(projectSlice.actions.itemDelete({ ids, undoable }));
        return;
    }
    const affectedPages = projectState.pages.reduce((accum, pageId) => {
        const page = projectState.page[pageId];
        if (page.pins.some(id => ids.includes(id))) {
            accum.push(pageId);
        }
        return accum;
    }, []);
    // lock history if will be updated after pin numbering is modified
    dispatch(projectSlice.actions.itemDelete({ ids }));
    dispatch(HistoryActions.lock());
    // get state after modifications
    const patches = {};
    // revisit all pins and fix numbers
    state = getState();
    projectState = getProjectState(state);
    const sizeFactor = getSizeFactor(state);
    affectedPages.forEach(pageId => {
        const page = projectState.page[pageId];
        page.pins.forEach((pinId, index) => {
            const marker = projectState.markers[pinId];
            const currentNumber = marker.number;
            const newNumber = index + 1;
            // if number 'length' has changed recalculate size
            // Math.floor(Math.log10(oldNumber)) !== Math.floor(Math.log10(newNumber))
            // NOTE: might be smart to always recalculate
            if (String(currentNumber).length !== String(newNumber).length) {
                patches[pinId] = updatePinOnSizeChange(marker, projectState.size, sizeFactor, { number: newNumber });
            }
            else {
                patches[pinId] = { number: newNumber };
            }
        });
    });
    dispatch(projectSlice.actions.itemsUpdate({ patches, undoable }));
    dispatch(HistoryActions.unlock());
}));
